/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';
import { investorDeclarationGetResponseSchema } from './investorDeclarationGetResponseSchema.ts';

/**
 * @description 200 response
 */
export const getInvestorDeclaration200Schema = z.lazy(() => investorDeclarationGetResponseSchema);

/**
 * @description 505 response
 */
export const getInvestorDeclaration505Schema = z.any();

export const getInvestorDeclarationQueryResponseSchema = z.lazy(() => getInvestorDeclaration200Schema);
